import useSessionStore from 'Context/useSessionStore'
import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { Loading } from 'Organisms/Loading'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import QuickbooksLogo from 'Assets/images/quickbooks.svg'
import { PlugsConnected } from '@phosphor-icons/react'
import { COLOR_BLACK, COLOR_WHITE } from 'constant/colors'
import { IntegrationElement, ExternalCalendars } from './Components'
import { QuickbooksIntegration } from './Quickbooks'

const Integrations = () => {
  const { user, updateUser } = useSessionStore((state) => ({ user: state.user, updateUser: state.updateUser }))
  const isAdmin = PERMISSION_BY_ROLE.SETTINGS.AUTOMATIC_CLOSE_HOURS.includes(user.role)
  const [loading, setLoading] = useState(false)
  const { control, register, handleSubmit, setValue } = useForm()
  const onSubmit = async (data) => {
    try {
      console.log('data', data)
    } catch (e) {

    }
  }
  return (
        <>
            {loading && <Loading />}
            <div className="col-12 d-grid align-content-start" onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-4 justify-content-between align-items-center">
                <div className="col-sm-auto col-12 d-flex align-items-center">
                  <h4>Integrations</h4>
                </div>
              </div>
              <div className='row'>
                <QuickbooksIntegration/>
              </div>
              <div className="row mb-4 justify-content-between align-items-center">
                <div className="col-sm-auto col-12 d-flex align-items-center">
                  <h4>External Calendars</h4>
                </div>
              </div>
              <div className='row'>
                <ExternalCalendars/>
              </div>
            </div>
        </>
  )
}
export default Integrations
